import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace OnLeashRunThrough {
  export const form: IEventRegisterRow[] = [
    {
      allowDuplicates: true,
      inputs: [{
        type: "dropdown",
        label: Constants.dog_class_element_level.on_leash_run_through_novice,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.on_leash_run_through_novice, id: Constants.dog_class_element_level.on_leash_run_through_novice }
        ]
      }]
    },
    {
      allowDuplicates: true,
      inputs: [{
        type: "dropdown",
        label: Constants.dog_class_element_level.on_leash_run_through_intermediate,
        options: [
          { value: "None", id: "None" },
          { value: Constants.dog_class_element_level.on_leash_run_through_intermediate, id: Constants.dog_class_element_level.on_leash_run_through_intermediate }
        ]
      }]
    }
  ];
}

